// extracted by mini-css-extract-plugin
export default {"posicionIcono":"Icono_posicionIcono__2i5hV"};